// @ts-check
import React, { Component } from "react"
import { createPortal } from "react-dom"
import { BlockContextConsumer } from "../ContextProviders"

class BlockActionsPortal extends Component {
    getList = context =>
        context.block.config.broadcast.filter(({ channel }) => channel === "action")
    render() {
        const children = (
            <BlockContextConsumer>
                {context =>
                    context.block &&
                    ((!this.getList(context).length && <em>(none)</em>) || (
                        <div onClick={event => event.stopPropagation()}>
                            <ul>{this.getList(context).map(({ name }) => <li>{name}</li>)}</ul>
                        </div>
                    ))
                }
            </BlockContextConsumer>
        )

        return createPortal(children, document.getElementById("actions"))
    }
}

BlockActionsPortal.propTypes = {}

export default BlockActionsPortal



// WEBPACK FOOTER //
// ./src/features/editor/actions/BlockActionsPortal.js